// src/pages/transportations/Transportations.jsx
import React from "react";
import WrapperSection from "../../components/global/WrapperSection";
import GlobalBreadcrumbs from "../../components/global/GlobalBreadcrumbs";
import TransportationsTable from "../../components/transportations/TransportationsTable";

const Transportations = () => {
    return (
        <WrapperSection>
            <GlobalBreadcrumbs />
            <TransportationsTable />
        </WrapperSection>
    );
};

export default Transportations;
